import en from './en/index'
import zh_tw from './zh-tw/index'
import th from './th/index'
const translations = { en, zh_tw, th }

export default translations
